import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

/** Detalhe de artigo/comunidade do site público — o conteúdo fica abaixo do hero. */
function isSiteArtigoDetailPath(pathname: string) {
  return /(^|\/)(artigos|comunidade)\/[^/]+\/?$/.test(pathname);
}

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const primeiraRota = useRef(true);

  useEffect(() => {
    const primeira = primeiraRota.current;
    primeiraRota.current = false;
    // Com o HTML do servidor na tela a pessoa pode já ter rolado antes do JS chegar.
    if (primeira && document.documentElement.classList.contains("ssr")) return;
    if (hash || isSiteArtigoDetailPath(pathname)) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}
